export default {"src":"/_next/static/media/mode_computer.39f983de.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};